import { AxiosInstance } from "axios";
import { getAccessToken } from "@/core/components/auth/services/cookies";
import { refreshTokenInterceptorResponse } from "@/core/utils/http/refresh-token-interceptor-response";

export const InterceptorStatusCode = (instance: AxiosInstance) => {
  instance.interceptors.request.use(
    (config) => {
      const token = getAccessToken();
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  instance.interceptors.response.use(
    (response) => response,
    refreshTokenInterceptorResponse(instance),
  );
};
